/* eslint-disable import/prefer-default-export */
import ApiRequest from './request';

export const createAdminApiUrl = (endpoint: string): string => {
  return `/admin/${endpoint}`;
};

export const getUsersApi = async (data: any) => {
  return ApiRequest.post(createAdminApiUrl('users'), data);
};

export const addUserApi = async (data: any) => {
  return ApiRequest.post(createAdminApiUrl('users/add'), data);
};

export const getUserApi = async (id: number) => {
  return ApiRequest.post(createAdminApiUrl('users/detail'), { id });
};

export const deleteUserApi = async (id: number) => {
  return ApiRequest.post(createAdminApiUrl('users/delete'), { id });
};

export const changePasswordUserApi = async (data: any) => {
  return ApiRequest.post(createAdminApiUrl('users/change-apssword'), data);
};

export const addItemCategoryApi = async (data: any) => {
  return ApiRequest.postWithAttachment(createAdminApiUrl('catalog/item-category/create'), data);
};

export const updateItemCategoryApi = async (data: any) => {
  return ApiRequest.postWithAttachment(createAdminApiUrl('catalog/item-category/update'), data);
};

export const deleteItemCategoryApi = async (id: number) => {
  return ApiRequest.post(createAdminApiUrl('catalog/item-category/delete'), { id });
};

export const addItemApi = async (data: any) => {
  return ApiRequest.postWithAttachment(createAdminApiUrl('catalog/items/create'), data);
};

export const updateItemApi = async (data: any) => {
  return ApiRequest.postWithAttachment(createAdminApiUrl('catalog/items/update'), data);
};

export const deleteItemApi = async (id: number) => {
  return ApiRequest.post(createAdminApiUrl('catalog/items/delete'), { id });
};

export const addSubItemApi = async (data: any) => {
  return ApiRequest.postWithAttachment(createAdminApiUrl('catalog/sub-items/create'), data);
};

export const updateSubItemApi = async (data: any) => {
  return ApiRequest.postWithAttachment(createAdminApiUrl('catalog/sub-items/update'), data);
};

export const deleteSubItemApi = async (id: number) => {
  return ApiRequest.post(createAdminApiUrl('catalog/sub-items/delete'), { id });
};

export const addAuctionApi = async (data: any) => {
  return ApiRequest.post('auctions/add', data);
};

export const getBidRequestListApi = async (data: any) => {
  return ApiRequest.post('/bids/applications', { ...data });
};

export const changeBidRequestStatusApi = async (data: any) => {
  return ApiRequest.post('/bids/applications/update', { ...data });
};

export const getAutoCompleteSearchApi = async (url: string, data: any) => {
  return ApiRequest.post(url, data);
};

export const addBuyerToAuctionApi = async (data: any) => {
  return ApiRequest.post(createAdminApiUrl('bids/add-buyer-to-auction'), { ...data });
};

export const removeBidRequestApi = async (data: any) => {
  return ApiRequest.post('/bids/applications/delete', { ...data });
};

export const adminAuctionAuctionApi = async (data: any) => {
  return ApiRequest.post(createAdminApiUrl('auctions'), { ...data });
};
